<template>
  <printBase ref="LinkQR030" :title='title' :id='id' :page='page' :width="800">
    <div v-for="(item, pageIndex) in printInfoList" :key="pageIndex" :slot="page==1? 'content' : `content${pageIndex+1}`" class="printLinkQR">
      <div class="printTitle">销售退回药品验收单</div>
      <table style="width: 100%" class='printContent' border='1' cellspacing="0">
        <tr height='40'>
          <td style="width: 12%"><span>退货日期</span></td>
          <td style="width: 20%"><span>{{printInfo.saleRefund.createTime}}</span></td>
          <td colspan="2" style="width: 12%"><span>销售日期</span></td>
          <td colspan="3" style="width: 21%"><span>{{item.saleOrderDetail.createTime}}</span></td>
          <td colspan="2" style="width: 15%"><span>销售凭证流水号码</span></td>
          <td style="width: 20%"><span>{{item.saleOrderDetail.orderNo}}</span></td>
        </tr>
        <tr height='140'>
          <td colspan="9" class="alignNone"><span class="leftTop">退货原因：{{item.saleRefundDetail.refundReason}}</span></td>
          <td class="alignNone"><span class="leftTop">退货人：{{item.saleRefundDetail.createUserName}}</span></td>
        </tr>
        <tr height='40'>
          <td><span>品名</span></td>
          <td><span>{{item.medicineInfoVo.approvedDrugNames}}</span></td>
          <td colspan="3"><span>剂型</span></td>
          <td colspan="3"><span>{{item.medicineInfoVo.dosageFormString}}</span></td>
          <td style="width: 11%"><span>规格</span></td>
          <td><span>{{item.medicineInfoVo.specifications}}</span></td>

        </tr>
        <tr height='40'>
          <td><span>批准文号</span></td>
          <td><span>{{item.medicineInfoVo.approvalCode}}</span></td>
          <td colspan="3"><span>批号</span></td>
          <td colspan="3"><span>{{item.saleOrderDetail.goodsLot}}</span></td>
          <td colspan="2" class='alignLeft'><span>有效期至：{{item.expiryDate}}</span></td>
        </tr>
        <tr height='40'>
          <td><span>生产企业</span></td>
          <td colspan="9"><span>{{item.medicineInfoVo.manufacturer}}</span></td>
        </tr>
        <tr height='40'>
          <td><span>数量</span></td>
          <td><span>{{item.saleRefundDetail.refundNum}}</span></td>
          <td style="width: 8%"><span>单位</span></td>
          <td colspan="2"><span>{{item.saleOrderDetail.goodsUnit}}</span></td>
          <td style="width: 8%"><span>单价</span></td>
          <td colspan="2"><span>{{item.saleRefundDetail.refundPrice}}</span></td>
          <td style="width: 8%"><span>金额</span></td>
          <td style="width: 8%"><span>{{item.saleRefundDetail.countAmount}}</span></td>
        </tr>
        <tr height='140'>
          <td colspan="10" class="alignNone">
            <div class="signOpinion">核实情况及检验结论：</div><br/>
            <span class="signContent">{{printInfo.saleRefund.inspectRecord}}</span>
            <div class="rightBottom"><span class="indentationRight">验收员：{{printInfo.saleRefund.refundInspector}}</span>
              <span v-if='printInfo.saleRefund.createTimeCheck'>{{ printInfo.saleRefund.createTimeCheck }}</span>
              <template v-else>
                <span style="margin-right:18px;">年</span>
                <span style="margin-right:18px;">月</span>
                <span>日</span>
              </template>
            </div>
          </td>
        </tr>
        <tr height='140'>
          <td colspan="10" class="alignNone">
            <div class="signOpinion">质量负责人审核意见：</div><br/>
            <span class="signContent">{{printInfo.qualityManagerIdea}}</span>
            <div class="rightBottom"><span class="indentationRight">签名：{{printInfo.qualityManagerName}}</span>
              <span v-if='printInfo.qualityManagerDate'>{{ printInfo.qualityManagerDate }}</span>
              <template v-else>
                <span style="margin-right:18px;">年</span>
                <span style="margin-right:18px;">月</span>
                <span>日</span>
              </template>
            </div>
          </td>
        </tr>
        <tr height='140'>
          <td colspan="10" class="alignNone">
            <div class="signOpinion">店长审核意见：</div><br/>
            <span class="signContent">{{printInfo.storeManagerIdea}}</span>
            <div class="rightBottom"><span class="indentationRight">店长：{{printInfo.storeManagerName}}</span>
              <span v-if='printInfo.storeManagerDate'>{{ printInfo.storeManagerDate }}</span>
              <template v-else>
                <span style="margin-right:18px;">年</span>
                <span style="margin-right:18px;">月</span>
                <span>日</span>
              </template>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </printBase>
</template>
<script>
import printBase from './printBase';
import afterSale from '../../services/afterSale';
import utils from '../../libs/utils';

export default {
  data() {
    return {
      title: 'Link-QR-030',
      id: 'LinkQR030',
      printInfo: {},
      printInfoList: [],
      page: 1,
    };
  },
  components: {
    printBase,
  },
  methods: {
    handlePrint(saleRefundId) {
      afterSale.saleRefundPrint({ saleRefundId }).then((res) => {
        if (res.data.status === 200) {
          const { auditRecordVoList, saleRefund, saleRefundDetailVoList } = res.data.data;

          //   saleRefund.refundInspector = utils.formatTime(saleRefund.refundInspector, 'YYYY年MM月DD日');
          const createTime = saleRefund.createTime;
          saleRefund.createTime = utils.exchangeTime(createTime);
          saleRefund.createTimeCheck = utils.formatTime(createTime, 'YYYY年MM月DD日');
          if (auditRecordVoList) {
            auditRecordVoList.forEach((elemAudit) => {
              if (elemAudit.roleId === 1) {
                this.printInfo.storeManagerIdea = elemAudit.idea;
                this.printInfo.storeManagerName = elemAudit.operateUserName;
                this.printInfo.storeManagerDate = utils.formatTime(elemAudit.operateTime, 'YYYY年MM月DD日');
              }
              if (elemAudit.roleId === 2) {
                this.printInfo.qualityManagerIdea = elemAudit.idea;
                this.printInfo.qualityManagerName = elemAudit.operateUserName;
                this.printInfo.qualityManagerDate = utils.formatTime(elemAudit.operateTime, 'YYYY年MM月DD日');
              }
            });
          }
          this.printInfo.saleRefund = saleRefund;
          this.printInfoList = saleRefundDetailVoList;
          this.printInfoList.forEach((item) => {
            item.expiryDate = utils.formatTime(item.expiryDate, 'YYYY年MM月DD日');
            item.saleRefundDetail.createTime = utils.exchangeTime(item.saleRefundDetail.createTime);
            item.saleOrderDetail.createTime = utils.exchangeTime(item.saleOrderDetail.createTime);
          });
          this.page = this.printInfoList.length;
          this.$nextTick(() => {
            this.$refs.LinkQR030.handlePrint();
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.printContent td,th{
    text-align: center;
    position: relative;
    border-color: #000;
    font-weight: 300;
    word-break: break-all;
    padding: 2px 6px;
    font-size: 12px;
    *{
      display: inline-block;
      max-height: 50px;
      overflow:hidden
    }

  }
</style>
